"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _discountAdapter = _interopRequireDefault(require("self-service-api/adapters/discountAdapter"));

var contactTierPriceMapAdapter = function contactTierPriceMapAdapter(merchandiseMap, merchandiseId, currencyCode, termId, currentSubscriptions) {
  var product = merchandiseMap[merchandiseId];

  if (!product) {
    throw new Error("Cannot find product for merchandiseId " + merchandiseId);
  }

  var pricingWrap = product.pricingWrap;
  var priceInfo = pricingWrap.tieredPrices.find(function (price) {
    return price.currencyCode === currencyCode;
  });

  if (!priceInfo) {
    throw new Error("Cannot find priceInfo for merchandiseId " + merchandiseId);
  } // If a termId is passed through, use it to calculate the discounted
  // prices of the contact tiers


  if (termId) {
    return priceInfo.priceTiers.map(function (priceTier) {
      var lowerBound = priceTier.lowerBound,
          upperBound = priceTier.upperBound,
          value = priceTier.value;
      return {
        lowerBound: lowerBound,
        upperBound: upperBound,
        // discount calculation
        value: value * (1 - (0, _discountAdapter.default)(merchandiseId, termId, currentSubscriptions, merchandiseMap))
      };
    });
  }

  return priceInfo.priceTiers;
};

var _default = contactTierPriceMapAdapter;
exports.default = _default;
module.exports = exports.default;